import { useScope } from "~/hooks/useScope";
import { PlatformPoliciesAddPage } from "~/pages/platform/policies-add/PlatformPoliciesAddPage";

export function PlatformPoliciesAddEntryPage() {
  const { regionScope } = useScope();
  return regionScope ? (
    <PlatformPoliciesAddPage scope={regionScope} />
  ) : undefined;
}
